import ReactDOM from 'react-dom';
export const Hydrate = ({ root, children }) => {
    const element = document.getElementById(root);
    if (!element)
        return null;
    window.performance.mark(`${root}-hydrate-start`);
    ReactDOM.hydrate(children, element);
    window.performance.mark(`${root}-hydrate-end`);
    window.performance.measure(`${root}-hydrate`, `${root}-hydrate-start`, `${root}-hydrate-end`);
    return null;
};
